import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import usePatientAppointments from "../../../../pages/ward/forms/scheduler/scheduledAppointments/usePatientAppointments";
import AgyleLoadingSpinner from "../../../other/agyleLoadingSpinner";
import moment from "moment";
import { find, orderBy } from "lodash";
import { SLOT_STATUSES } from "../../../../pages/appointments/utils/constants/appointmentSessionConstants";

const BookedPatientDetails = ({ patient }) => {
  const { t } = useTranslation();

  const [appointmentList, appointmentsLoading] = usePatientAppointments({
    hospitalNumber: patient?.patient?.__id,
    startDate: moment().format("DD-MM-YYYY"),
  });

  const getStatus = (status) => {
    return find(SLOT_STATUSES, (s) => s.value === status);
  };

  const renderAppointment = () => {
    if (appointmentsLoading) {
      return (
        <AgyleLoadingSpinner
          disableText
          spinnerSize={16}
          textAlign="flex-start"
        />
      );
    }

    if (!appointmentList || appointmentList.length === 0) {
      return (
        <Typography variant="body1">{t("No appointments found")}</Typography>
      );
    }

    const sortedAppointments = orderBy(appointmentList, ["startDate"], ["asc"]);

    return sortedAppointments.map((appointment, index) => {
      const status = getStatus(appointment?.status);

      return (
        <div key={index}>
          <Typography variant="body1">
            {moment(appointment?.startDate).format("DD/MM/YYYY")} -{" "}
            {moment(appointment?.startDate).format("HH:mm")}
            {" - "}
            {status?.name || "N/A"}
          </Typography>
        </div>
      );
    });
  };

  return (
    <Grid item xs={12} className="container-grid">
      <Typography variant="body1" className="title">
        {t("Upcoming Appointments")}
      </Typography>

      {renderAppointment()}
    </Grid>
  );
};

export default BookedPatientDetails;
